(function () {
  var SUGGEST_PATH = '/search/suggest.json';
  var HIDE_TITLE_RE = /\s-\sBackend/i;

  function isSuggestUrl(url) {
    if (!url) return false;
    var s = typeof url === 'string' ? url : (url.url || '');
    return s.indexOf(SUGGEST_PATH) !== -1;
  }

  function isZeroPrice(p) {
    if (!p || p.price == null) return false;
    var n = parseFloat(String(p.price).replace(/[^0-9.\-]/g, ''));
    return !isNaN(n) && n <= 0;
  }

  function shouldHide(p) {
    if (!p) return false;
    if (p.title && HIDE_TITLE_RE.test(p.title)) return true; // 기존 "- Backend" 제목 규칙 유지
    if (isZeroPrice(p)) return true;                         // 가격 0(백엔드/구성품) 자동 숨김
    return false;
  }

  function filterPayload(payload) {
    try {
      if (!payload || !payload.resources || !payload.resources.results) return payload;
      var results = payload.resources.results;
      if (Array.isArray(results.products)) {
        results.products = results.products.filter(function (p) {
          return !shouldHide(p);
        });
      }
    } catch (_) {}
    return payload;
  }

  // ---- fetch intercept ----
  if (typeof window.fetch === 'function') {
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var p = origFetch(input, init);
      if (!isSuggestUrl(url)) return p;
      return p.then(function (resp) {
        if (!resp || !resp.ok) return resp;
        var ct = resp.headers && resp.headers.get && resp.headers.get('content-type') || '';
        if (ct.indexOf('json') === -1) return resp;
        return resp.clone().json().then(function (data) {
          var filtered = filterPayload(data);
          return new Response(JSON.stringify(filtered), {
            status: resp.status,
            statusText: resp.statusText,
            headers: resp.headers
          });
        }).catch(function () { return resp; });
      });
    };
  }

  // ---- XMLHttpRequest intercept ----
  // The Shopify predictive-search library uses `xhr.onreadystatechange = fn`
  // (DOM Level 0). To run BEFORE the library reads responseText, we must
  // wrap its onreadystatechange after .send() is invoked but before the
  // browser fires the readystatechange callbacks.
  if (typeof window.XMLHttpRequest === 'function') {
    var XHR = window.XMLHttpRequest;
    var origOpen = XHR.prototype.open;
    var origSend = XHR.prototype.send;

    XHR.prototype.open = function (method, url) {
      this.__kgSuggest = isSuggestUrl(url);
      return origOpen.apply(this, arguments);
    };

    XHR.prototype.send = function () {
      if (this.__kgSuggest) {
        var self = this;
        var origORSC = self.onreadystatechange;
        self.onreadystatechange = function () {
          if (self.readyState === 4 && !self.__kgFiltered) {
            self.__kgFiltered = true;
            try {
              var ct = self.getResponseHeader && self.getResponseHeader('content-type') || '';
              if (ct.indexOf('json') !== -1) {
                var data = JSON.parse(self.responseText);
                var filtered = filterPayload(data);
                var filteredText = JSON.stringify(filtered);
                Object.defineProperty(self, 'responseText', { configurable: true, get: function () { return filteredText; } });
                Object.defineProperty(self, 'response', { configurable: true, get: function () { return filteredText; } });
              }
            } catch (_) {}
          }
          if (typeof origORSC === 'function') {
            return origORSC.apply(self, arguments);
          }
        };
      }
      return origSend.apply(this, arguments);
    };
  }
})();
